// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__Cl2fJ","change-color-on-hover":"BookNowBtn_change-color-on-hover__nF6LQ","button":"BookNowBtn_button__DDJNY"};